// extracted by mini-css-extract-plugin
export var top = "Footer-module--top--LzXfr";
export var bottom = "Footer-module--bottom--CwQoq";
export var address = "Footer-module--address--77ddr";
export var menu = "Footer-module--menu--2D2Iu";
export var logo = "Footer-module--logo--3u1Kk";
export var copyright = "Footer-module--copyright--36KRg";
export var socialMedia = "Footer-module--socialMedia--UxBvG";
export var left = "Footer-module--left--17uHV";